<template>
  <div>
    <base-header class="pb-6" />
    <b-container fluid class="mt--6 max-width">
      <b-card no-body>

        <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
          <b-form id="entity_form" role="form" @submit.prevent="handleSubmit(onSubmit)">

            <card-header title="Edit Entity object attributes">
              <base-button type="white" size="sm" @click="onCancel">Cancel</base-button>
              <base-button type="success" size="sm" native-type="submit" :loading="isLoading">Save</base-button>
            </card-header>

            <b-card-body>
              <b-row>

                <b-col md="6">
                  <base-input label="Name" name="name" v-model="form.name" disabled />
                </b-col>

                <b-col md="6">
                  <base-input label="Description" v-model="form.description "  />
                </b-col>

              </b-row>

              <b-row>

                <b-col md="6">
                  <fieldset class="form-group">
                    <label class="form-control-label">Alloc Info <span class="font-weight-light">Optional</span></label>

                    <base-input :rules="{json: true}">
                      <textarea class="form-control font-mono" rows="6" v-model="form.allocinfo" />
                    </base-input>

                    <file-loader
                        initialLabel="Load JSON file"
                        accept=".json"
                        :maxSize="100000"
                        :parse-json="false"
                        :content.sync="form.allocinfo" />
                  </fieldset>
                </b-col>

                <b-col md="6">
                  <fieldset class="form-group">
                    <label class="form-control-label">Global Info <span class="font-weight-light">Optional</span></label>

                    <base-input :rules="{json: true}">
                      <textarea class="form-control font-mono" rows="6" v-model="form.globalinfo" />
                    </base-input>

                    <file-loader
                        initialLabel="Load JSON file"
                        accept=".json"
                        :maxSize="100000"
                        :parse-json="false"
                        :content.sync="form.globalinfo" />

                  </fieldset>
                </b-col>
                <b-col md="6">
                  <fieldset class="form-group">
                    <label class="form-control-label">Unalloc Info <span class="font-weight-light">Optional</span></label>

                    <base-input :rules="{json: true}">
                      <textarea class="form-control font-mono" rows="6" v-model="form.unallocinfo" />
                    </base-input>

                    <file-loader
                        initialLabel="Load JSON file"
                        accept=".json"
                        :maxSize="100000"
                        :parse-json="false"
                        :content.sync="form.unallocinfo" />

                  </fieldset>
                </b-col>
      

              </b-row>


              <!-- License Tier Dropdown -->
              <!-- This section is License -->
               <!--
              <b-col md="6">
                <b-form-group label="License Tier" label-for="license-tier-select">
                  <b-form-select
                    id="license-tier-select"
                    v-model="form.license_tier"
                    :options="licenseTierOptions"
                    required
                  >
                    <template #first>
                      <option value="" disabled>Select a license tier</option>
                    </template>
                  </b-form-select>
                </b-form-group>
              </b-col>
              -->
              <!-- End of new section -->

            </b-card-body>
          </b-form>
        </validation-observer>
          <b-card-body>
          <b-row>
            <b-col>
              <base-button 
                type="primary" 
                size="sm" 
                @click="showResourcesModal"
              >
                <i class="fas fa-folder-open mr-1"></i> Manage Resources
              </base-button>
                <base-button 
                type="info" 
                size="sm" 
                class="ml-2"
                @click="showTTNModal"
              >
                <i class="fas fa-broadcast-tower mr-1"></i> LoRa / TTN Integration
              </base-button>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
    </b-container>
   
  <upload-modals
  ref="uploadModals"
  title="Entity"
  :id="form.name"
  :site-id="form.site"
  :existing-files="existingFiles"
  :existing-firmware="existingFirmware"
  :existing-icons="existingIcons"                     
  @upload-file="uploadFile"
  @upload-firmware="uploadFirmware"
  @upload-icon="onUploadIcon"                         
  @delete-file="confirmDeleteFile"
  @delete-firmware="confirmDeleteFirmware"
  @delete-icon="confirmDeleteIcon"                   
  @fetch-files="fetchEntityFiles"
  @fetch-firmware="fetchEntityFirmware"
  @fetch-icons="fetchEntityIcons"                    
  @firmware-tab-activated="syncGitlab"
/>
  <entity-ttn-modal ref="ttnModal" />
  </div>
</template>

<script>

import {Routes} from "@/router";
import {Action} from "@/store/actions";
import {MapEntityConfig} from "@/services/map.service";
import FileLoader from "@/views/components/FileLoader";
import UploadModals from "@/views/components/UploadModals";
import EntityTTNModal from "@/views/components/EntityTTNModal";
export default {
  name: "EntityEdit",
  components: {
    FileLoader,
    UploadModals,
          'entity-ttn-modal': EntityTTNModal


  },
  data() {
    return {
       syncingGitlab: false,
      form: {
        name: '',
        description: '',
        globalinfo: undefined,
        allocinfo: undefined,
        unallocinfo:undefined,
        devicePath: "",
        uploading: false,
        license_tier: '' // This is new and not present in the first code
      },
         fileToUpload: null,
      accept: '*/*', // Accept all file types
      maxSize: 10000000, // 10MB max size
      isLoading: true,
      //showFileModal: false,
      existingFiles: [],
      fileFields: [
        { key: 'filename', label: 'File Name' },
        { key: 'file_device_path', label: 'Device Path' },
        { key: 'upload_date', label: 'Upload Date' },
        { key: 'size_bytes', label: 'Size', formatter: value => this.formatFileSize(value) },
        { key: 'actions', label: 'Actions' }
      ],
      activeTab: 0,
      //showFirmwareModal: false,
      existingFirmware: [],
      firmwareFields: [
        { key: 'version', label: 'Version' },
        { key: 'device_type', label: 'Device Type' },
        { key: 'filename', label: 'File Name' },
        { key: 'release_date', label: 'Upload Date' },
        { key: 'actions', label: 'Actions' }
      ],
      firmwareFile: null,
      firmwareVersion: '',
      firmwareDescription: '',
      firmwareUploading: false,
      activeFirmwareTab: 0,
      licenseTierOptions: [ // This is new and not present in the first code
        { value: 'basic', text: 'Basic' },
        { value: 'pro', text: 'Pro' }
      ],
      deviceTypeOptions: [
      { value: 'CC1', text: 'CC1' },
      { value: 'CC2', text: 'CC2' }
    ],
    existingIcons: [],
iconFields: [
  { key: 'filename', label: 'Original Name' },
  { key: 'converted_filename', label: 'Converted Name' },
  { key: 'format', label: 'Format' },
  { key: 'file_device_path', label: 'Device Path' },
  { key: 'upload_date', label: 'Upload Date' },
  { key: 'size_bytes', label: 'Size', formatter: value => this.formatFileSize(value) },
  { key: 'actions', label: 'Actions' }
],
      firmwareDeviceType: 'CC2'
    };
  },
     
  computed: {
  
     canUploadFirmware() {
      return this.firmwareFile && 
             this.firmwareVersion && 
             this.firmwareDeviceType
    }
  },
  methods: {
    async syncGitlab() {
  // Get entity from route params (e.g., this.$route.params.entity)
  const entity = this.form.name;
    if (!entity) {
        this.$notify({ type: 'danger', title: 'Error', text: 'Entity name not loaded.' });
        return;
    }

  this.syncingGitlab = true;
  try {
    const resp = await this.$http.post(
      `/tenant/${entity}/firmware/sync-gitlab?device_type=CC2`
    );
 
    await this.fetchSiteFirmware();   // refresh firmware list
  } catch (e) {
    let msg = 'Unexpected error';
    if (e.response) {
      const data = e.response.data || {};
      msg = data.error || data.message || `Server error ${e.response.status}`;
    } else if (e.request) {
      msg = 'No response from server – check network.';
    } else {
      msg = e.message;
    }
  } finally {
    this.syncingGitlab = false;
  }
},
       showFileModal() {
      this.$refs.uploadModals.showFilesModal();
    },
        showResourcesModal() {
      this.$refs.uploadModals.openModal(0); // open Files tab by default
    },
  showTTNModal() {
  if (!this.form.name) {
    this.$notify({ type: 'warning', title: 'Not ready', text: 'Entity has not loaded yet.' });
    return;
  }
  this.$refs.ttnModal.show(this.form.name);
},

    
    showFirmwareModal() {
      this.$refs.uploadModals.showFirmwaresModal();
    },
    onCancel() {
      this.$router.push({name: Routes.home})
    },
    onSubmit() {
     //console.log('License Tier:', this.form.license_tier); // Debug log
     //console.log('Form Data:', this.form); // Debug log for the entire form
      this.isLoading = true

      const model = MapEntityConfig.formToModel(this.form)
     //console.log('Mapped Model:', model); // Debug log for the transformed model
      this.$store.dispatch(Action.entity.saveConfig, model)
        .then(() => {
          this.$router.push({name: Routes.home})
        }).catch(error => {
          this.isLoading = false
          console.error(error)
        })
    },
    resetFileUpload() {
      this.activeTab = 0;
      this.fileToUpload = null;
      this.devicePath = "";
      this.uploading = false;
    },
    
    resetFirmwareUpload() {
      this.activeFirmwareTab = 0;
      this.resetFirmwareForm();
      this.firmwareUploading = false;
    },
        // Add these two methods:
    onFileLoaded(fileContent, fileName) {
      this.fileToUpload = {
        content: fileContent,
        name: fileName
      };
    },
    
    // In your Vue component
    async uploadFile(fileData, callback) {

    try {
        const formData = new FormData();
        formData.append('file', new Blob([fileData.content]), fileData.name);
        formData.append('entity_id',  fileData.id);
        formData.append('level', 'entity');
        if (fileData.devicePath) {
          formData.append('file_device_path', fileData.devicePath);
        }
        // Use the store action instead of direct API call
        await this.$store.dispatch(Action.entity.uploadEntityFile, formData);
        
        this.$notify({
            type: 'success',
            title: 'File Upload',
            text: 'File uploaded successfully!'
        });
        

callback();
        
    } catch (error) {
        this.$notify({
            type: 'danger',
            title: 'File Upload Failed',
            text: error.response?.data?.message || 'Failed to upload file'
        });
    }
    },
    async onUploadIcon(iconData, callback) {
   // console.log('[EntityEdit] onUploadIcon CALLED', iconData); 
  try {
    const formData = new FormData();
    formData.append('file', new Blob([iconData.content]), iconData.name);
    formData.append('entity_id', iconData.id);
    formData.append('level', 'entity');
    if (iconData.devicePath) {
      formData.append('file_device_path', iconData.devicePath);
    }
    if (iconData.description) {
      formData.append('description', iconData.description);
    }
    await this.$store.dispatch(Action.entity.uploadEntityIcon, formData);
    this.$notify({ type: 'success', title: 'Icon Upload', text: 'Icon uploaded successfully!' });
    callback();
    this.fetchEntityIcons();
  } catch (error) {
    this.$notify({ type: 'danger', title: 'Icon Upload Failed', text: error.response?.data?.message || 'Failed to upload icon' });
    callback();
  }
},

async fetchEntityIcons() {
  try {
    const response = await this.$store.dispatch(Action.entity.listEntityIcons, this.form.name);
    this.existingIcons = response?.icons || [];
  } catch (error) {
    console.error("Failed to fetch entity icons", error);
  }
},

confirmDeleteIcon(icon) {
  this.$bvModal.msgBoxConfirm(`Delete ${icon.filename}? This cannot be undone.`, {
    title: 'Confirm Delete',
    okVariant: 'danger',
    okTitle: 'Delete',
    cancelTitle: 'Cancel',
    centered: true
  }).then(confirmed => {
    if (confirmed) this.deleteIcon(icon);
  });
},

async deleteIcon(icon) {
  try {
    await this.$store.dispatch(Action.entity.deleteEntityIcon, icon.id);
    this.$notify({ type: 'success', title: 'Icon Deleted', text: `${icon.filename} was removed` });
    await this.fetchEntityIcons();
  } catch (error) {
    console.error("Failed to delete icon", error);
    this.$notify({ type: 'danger', title: 'Delete Failed', text: 'Failed to delete icon' });
  }
},

confirmDeleteAllIcons() {
  this.$bvModal.msgBoxConfirm(`Delete all ${this.existingIcons.length} icons? This cannot be undone.`, {
    title: 'Confirm Delete All',
    okVariant: 'danger',
    okTitle: 'Delete All',
    cancelTitle: 'Cancel',
    centered: true
  }).then(confirmed => {
    if (confirmed) this.deleteAllIcons();
  });
},

async deleteAllIcons() {
  try {
    await this.$store.dispatch(Action.entity.deleteAllEntityIcons, this.form.name);
    this.$notify({ type: 'success', title: 'Icons Deleted', text: `All icons removed` });
    this.existingIcons = [];
  } catch (error) {
    console.error("Failed to delete all icons", error);
    this.$notify({ type: 'danger', title: 'Delete Failed', text: 'Failed to delete all icons' });
  }
},
    async fetchEntityFiles() {
  try {
    const response = await this.$store.dispatch(
      Action.entity.listEntityFiles, 
      this.form.name
    );
    this.existingFiles = response.files || [];
  } catch (error) {
    console.error("Failed to fetch entity files", error);
  }
    },
    
    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return date.toLocaleDateString() + ' ' + date.toLocaleTimeString();
    },
    
    formatFileSize(bytes) {
      if (bytes === 0) return '0 Bytes';
      const k = 1024;
      const sizes = ['Bytes', 'KB', 'MB', 'GB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    },
    
    confirmDeleteFile(file) {
      this.$bvModal.msgBoxConfirm(`Delete ${file.filename}? This cannot be undone.`, {
        title: 'Confirm Delete',
        okVariant: 'danger',
        okTitle: 'Delete',
        cancelTitle: 'Cancel',
        centered: true
      }).then(confirmed => {
        if (confirmed) {
          this.deleteFile(file);
        }
      });
    },
    async deleteFile(file) {
  try {
    await this.$store.dispatch(
      Action.entity.deleteEntityFile, 
      file.id
    );
     this.$notify({
          type: 'success',
          title: 'File Deleted',
          text: `${file.filename} was successfully removed`
        });
    await this.fetchEntityFiles(); // Refresh list
  } catch (error) {
    console.error("Failed to delete file", error);
  }
    },
    confirmDeleteAllFiles() {
    this.$bvModal.msgBoxConfirm(
      `Delete all ${this.existingFiles.length} files? This cannot be undone.`,
      {
        title: 'Confirm Delete All',
        okVariant: 'danger',
        okTitle: 'Delete All',
        cancelTitle: 'Cancel',
        centered: true
      }
    ).then(confirmed => {
      if (confirmed) {
        this.deleteAllFiles();
      }
    });
    },
  
    async deleteAllFiles() {
    try {
      await this.$store.dispatch(
        Action.entity.deleteAllEntityFiles, 
        this.form.name
      );
      
      this.$notify({
        type: 'success',
        title: 'Files Deleted',
        text: `All ${this.existingFiles.length} files were successfully removed`
      });
      
      this.existingFiles = [];
    } catch (error) {
      console.error("Failed to delete all files", error);
      this.$notify({
        type: 'danger',
        title: 'Delete Failed',
        text: 'Failed to delete all files'
      });
    }
    },
  
  
    onFirmwareFileLoaded(fileContent, fileName) {
      this.firmwareFile = {
        content: fileContent,
        name: fileName
      }
      },
    
    async uploadFirmware(firmwareData, callback) {
    
      try {
        const formData = new FormData();
        formData.append('firmware_file', new Blob([firmwareData.content]), firmwareData.name);
        formData.append('version', firmwareData.version);
    formData.append('device_type', firmwareData.deviceType);
    formData.append('description', firmwareData.description);
        formData.append('level', 'entity');
        formData.append('entity_id',  firmwareData.id);
           if (firmwareData.wifiContent) {
      formData.append('wifi_firmware_file', new Blob([firmwareData.wifiContent]), firmwareData.wifiName);
    }

          await this.$store.dispatch(Action.entity.uploadEntityFirmware, formData);
        
        this.showNotification('Firmware uploaded successfully!', 'success');
        this.resetFirmwareForm();
        this.$nextTick(this.resetFirmwareUpload);
         callback(true);
      } catch (error) {
        this.showNotification('Firmware upload failed', 'danger', error);
      }
    },
     async fetchEntityFirmware() {
      try {
        const response = await this.$store.dispatch(
          Action.entity.listEntityFirmware, 
          this.form.name
        );
        this.existingFirmware = response || [];
      } catch (error) {
        console.error("Failed to fetch entity firmware", error);
      }
    },
    
    confirmDeleteFirmware(firmware) {
      this.$bvModal.msgBoxConfirm(`Delete ${firmware.filename}? This cannot be undone.`, {
        title: 'Confirm Delete',
        okVariant: 'danger',
        okTitle: 'Delete',
        cancelTitle: 'Cancel',
        centered: true
      }).then(confirmed => {
        if (confirmed) {
          this.deleteFirmware(firmware);
        }
      });
    },
    
    async deleteFirmware(firmware) {
       const originalList = [...this.existingFirmware];
      try {
       
    
        // Optimistically remove the firmware from the list
        this.existingFirmware = this.existingFirmware.filter(fw => fw.id !== firmware.id);
       //console.log(firmware.id);
        await this.$store.dispatch(
          Action.entity.deleteEntityFirmware, 
          firmware.id 
        );
         this.showNotification(
          `Firmware ${firmware.filename} (v${firmware.version}) deleted successfully!`,
          'success'
        );
        await this.fetchEntityFirmware();
      } catch (error) {
            this.existingFirmware = originalList;

         this.showNotification(
          'Firmware deletion failed', 
          'danger', 
          error
        );
        console.error("Failed to delete firmware", error);
      }
    },
    confirmDeleteAllFirmware() {
    this.$bvModal.msgBoxConfirm(
      `Delete all ${this.existingFirmware.length} firmware files? This cannot be undone.`,
      {
        title: 'Confirm Delete All',
        okVariant: 'danger',
        okTitle: 'Delete All',
        cancelTitle: 'Cancel',
        centered: true
      }
    ).then(confirmed => {
      if (confirmed) {
        this.deleteAllFirmware();
      }
    });
    },
  
    async deleteAllFirmware() {
    try {
      await this.$store.dispatch(
        Action.entity.deleteAllEntityFirmware, 
        {
          entityId: this.form.name,
          deviceType: 'cc2' // Default device type
        }
      );
      
      this.$notify({
        type: 'success',
        title: 'Firmware Deleted',
        text: `All ${this.existingFirmware.length} firmware files were successfully removed`
      });
      
      this.existingFirmware = [];
    } catch (error) {
      console.error("Failed to delete all firmware", error);
      this.$notify({
        type: 'danger',
        title: 'Delete Failed',
        text: 'Failed to delete all firmware'
      });
    }
    },
    resetFirmwareForm() {
      this.firmwareFile = null;
      this.firmwareVersion = '';
      this.firmwareDeviceType = '';
      this.firmwareDescription = '';
    },
    
    showNotification(message, type, error = null) {
      const text = error
        ? error.response?.data?.message || 'An unexpected error occurred'
        : message;
      
      this.$notify({
        type,
        title: type === 'success' ? 'Success' : 'Error',
        text
      });
    }
 

  },
  mounted() {
    this.$store.dispatch(Action.entity.loadConfig)
        .then(() => {
          this.isLoading = false
          this.form = MapEntityConfig.modelToForm(this.$store.state.entity.entityConfig, this.form)
        })
  }
}

</script>

